import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { profileLayoutDesktopFrameStyles } from '@/features/Profile/core/ProfileLayout/ProfileLayout.styled';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  ${profileLayoutDesktopFrameStyles}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 20px;
    padding: 10px 20px 15px;
    border-radius: 0 0 21px 21px;
  }
`;

export const Title = styled(Typography.Header).attrs({
  $variant: '2',
})`
  padding-bottom: 10px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-bottom: 0;
    font-size: 24px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px 30px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const MoreInfo = styled(Typography.Caption)`
  text-align: center;

  a {
    color: ${({ theme }) => theme.palette.system.blue};
    text-decoration: none;
  }
`;
